import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";

const AddStaffSalary = ({ getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const formRef = useRef(null);
  const [companyId, setCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [staff, setStaff] = useState([]);
  const [staffId, setStaffId] = useState("");
  const [rowAddData, setRowAddData] = useState({
    company_id: "",
    date: "",
    staff_name: "",
    attendance: "",
    basic: "",
    da: "",
    salary: "",
    net_salary: "",
    advance: "",
    amount: "",
  });

  function resetFileds() {
    setRowAddData({
      company_id: "",
      date: "",
      staff_name: "",
      attendance: "",
      basic: "",
      da: "",
      salary: "",
      net_salary: "",
      advance: "",
      amount: "",
    });
    setCompanyId("");
    setStaffId("");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const getStaff = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };

  useEffect(() => {
    if (companyId) {
      getStaff();
    }
  }, [companyId]);
  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setStaffId(e.target.value);
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      company_id,
      date,
      staff_name,
      attendance,
      basic,
      da,
      salary,
      net_salary,
      advance,
      amount,
    } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/staff-salary/staff-salary/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
        date,
        staff_id: staffId,
        attendance,
        basic,
        da,
        salary,
        net_salary,
        advance,
        amount,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useState(() => {
    getCompany();
  }, []);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="salaryModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Staff Salary Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Staff Salary Details</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Product">Date</label>

                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="Product"
                              placeholder="Date"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.date}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={companyId}
                              required
                              autoComplete="off"
                              id="company_id"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option value={item.id}>
                                        {`${item.company_name}, ${item.location}`}
                                      </option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="employee_name">Employee Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={staffId}
                              required
                              autoComplete="off"
                              id="employee_name"
                            >
                              <option value="">Select</option>
                              {staff &&
                                staff?.length > 0 &&
                                staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="basic">Basic%</label>
                            <input
                              type="number"
                              className="form-control"
                              name="basic"
                              id="basic"
                              placeholder="Basic%"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.basic}
                              min="1"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="da">DA%</label>
                            <input
                              type="number"
                              className="form-control"
                              name="da"
                              id="da"
                              placeholder="DA%"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.da}
                              min="1"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="attendance">Attendance</label>
                            <input
                              type="number"
                              className="form-control"
                              name="attendance"
                              id="attendance"
                              placeholder="Attendance"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.attendance}
                              min="1"
                            />
                          </div>
                        </div>
                 
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="salary">Salary</label>
                            <input
                              type="number"
                              className="form-control"
                              name="salary"
                              id="salary"
                              placeholder="Salary"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.salary}
                              min="1"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="net_salary">Net Salary</label>
                            <input
                              type="number"
                              className="form-control"
                              name="net_salary"
                              id="net_salary"
                              placeholder="Net Salary"
                              onChange={handleChange}
                              // required
                              autoComplete="off"
                              value={rowAddData.net_salary}
                              min="1"
                            />
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="advance">Advance</label>
                            <input
                              type="number"
                              className="form-control"
                              name="advance"
                              id="advance"
                              placeholder="Advance"
                              onChange={handleChange}
                              // required
                              autoComplete="off"
                              value={rowAddData.advance}
                              min="0"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Amount">Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="amount"
                              id="Amount"
                              placeholder="Amount"
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
               </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddStaffSalary;
